import { InjectionToken } from "@angular/core";

import { CurrentLoginSource } from "./auth.model";
import { SESSION_ACTION_TYPE } from "./session.action";

export const AUTH_ROUTE = {
	login: "login",
	bankIdVerification: "bank-id-verification",
	suspiciousLogin: "suspicious-login",
	twoFactorAuthentication: "two-factor-authentication",
	acceptAndPlay: "accept-and-play",
	openIdConnect: "oidc-verify",
	redirectionVerify: "redirection-verify",
	registrationOidc: "registration-oidc",
	// todo: OBGB-11917 - move login related logic to common
	forgotPassword: "forgot-password",
	resetPasswordByEmail: "reset-password-by-email",
	resetPasswordBySms: "reset-password-by-sms",
	resetPassword: "reset-password",
	resetPasswordTokenOnly: "reset-password-token-only",
	resetPasswordEmailToken: "reset-password-email-token",
};

export const AUTH_MESSAGE_CONTEXT = {
	login: SESSION_ACTION_TYPE.login,
	loginWithVerificationCode: SESSION_ACTION_TYPE.loginWithVerificationCode,
	loginWithPersonalNumber: SESSION_ACTION_TYPE.loginWithPersonalNumber,
	loginWithTwoFactorAuthentication: SESSION_ACTION_TYPE.loginWithTwoFactorAuth,
	loginWithToken: SESSION_ACTION_TYPE.loginWithToken,
	loginWithAuthenticationToken: SESSION_ACTION_TYPE.loginWithAuthenticationToken,
	loginBrandRedirection: SESSION_ACTION_TYPE.loginBrandRedirection,
	logout: SESSION_ACTION_TYPE.logout,
	verify: SESSION_ACTION_TYPE.verify,
};

export const AUTH_MESSAGE_CODES = {
	changePassword: {
		success: "M_CHANGE_PASSWORD_SUCCESS",
		invalidCredentials: "E_CREDENTIALS_INVALIDCREDENTIALS",
		passwordHistory: "E_CREDENTIALS_PASSWORD_HISTORY",
		twoFactorAuthRequired: "E_CREDENTIALS_PASSWORD_CHANGE_2FAREQUIRED",
	},
	forgotPassword: {
		error: "E_FORGOTTENPASSWORDS",
		securityQuestion: "E_FORGOTTENPASSWORDS_SECURITYQUESTION",
		success: "M_FORGOT_PASSWORD_SUCCESS",
		tokenNotFound: "E_FORGOTTENPASSWORDS_TOKENNOTFOUND",
		passwordNotDifferent: "E_FORGOTTENPASSWORDS_INVALIDNEWPASSWORD",
		passwordHistory: "E_FORGOTTENPASSWORDS_PASSWORD_HISTORY",
		tokenInvalidValue: "E_VALIDATION_INVALIDVALUE",
		tokenExpired: "E_INVALID_PASSWORD_REQUEST_EXPIRED",
	},
	login: {
		accountNotVerified: "E_SESSIONS_LOGIN_ACCOUNTNOTVERIFIED",
		accountValidated: "M_SESSIONS_LOGIN_ACCOUNTVALIDATED",
		customerNotAllowed: "E_SESSIONS_LOGIN_CUSTOMERNOTALLOWED",
		customerSelfExcluded: "E_SESSIONS_LOGIN_CUSTOMERSELFEXCLUDED",
		customerSelfExcludedFromGamstop: "E_SESSIONS_LOGIN_CUSTOMERSELFEXCLUDEDFROMGAMSTOP",
		customerSelfExcludedFromSga: "E_SESSIONS_LOGIN_CUSTOMERSELFEXCLUDEDFROMSGA",
		error: "E_SESSIONS_LOGIN",
		invalidCredentials: "E_SESSIONS_LOGIN_INVALIDCREDENTIALS",
		credentialsNotFound: "E_SESSIONS_LOGIN_CREDENTIALNOTFOUND",
		maxAttemptsReached: "E_SESSIONS_LOGIN_MAXATTEMPTSREACHED",
		termsAndConditionsNotAccepted: "E_SESSIONS_LOGIN_TERMSANDCONDITIONSNOTACCEPTED",
		latestTermsAndConditionsNotAccepted: "E_SESSIONS_LOGIN_LATESTTERMSANDCONDITIONSNOTACCEPTED",
		consentsNotAccepted: "E_SESSIONS_LOGIN_CONSENTSNOTACCEPTED",
		customerNotVerified: "E_AUTHENTICATION_CUSTOMER_NOTVERIFIED",
		sessionLimitExpired: "E_SESSION_LOGIN_SESSIONLIMITEXPIRED",
		typeNotAllowed: "E_SESSIONS_LOGIN_TYPENOTALLOWED",
		twoFactorAuthenticationRequired: "E_SESSIONS_LOGIN_2FAREQUIRED",
		twoFactorAuthenticationMaxAttemptReached: "E_SESSIONS_LOGIN_2FA_MAXIMUM_ATTEMPTS_REACHED",
		latestPrivacyPolicyNotAccepted: "E_SESSIONS_LOGIN_LATESTPRIVACYPOLICYNOTACCEPTED",
		latestEntityLegalNoticeNotAccepted: "E_SESSIONS_LOGIN_LATESTENTITYLEGALNOTICENOTACCEPTED",
		resetPasswordRequired: "E_CREDENTIALS_PASSWORD_RESET_REQUIRED",
		profileNotCompleted: "E_SESSIONS_LOGIN_CUSTOMERDATANOTCONFIRMED",
		disallowedErrorCode: "DISALLOWED_ERROR_CODE",
		customerPepSanctioned: "E_SESSIONS_LOGIN_SANCTIONED",
		geofencingMultipleTries: "geofencing-multiple-tries-error",
		geofencingGeneralError: "geofencing-general-error",
		geofencingServerError: "geofencing-server-error",
	},
	singleSignOn: {
		siteCoreCookieNotInHeader: "E_SINGLESIGNONSESSIONS_SITECORECOOKIENOTINHEADER",
	},
};

export const AUTH_INVALID_SESSION_ERROR_CODES = {
	invalidSession: "E_INVALIDSESSIONTOKEN",
	invalidSessionSimultaneousLogin: "E_INVALIDSESSIONTOKEN_SIMULTANEOUS_LOGIN",
	invalidSessionLogout: "E_INVALIDSESSIONTOKEN_LOGOUT",
	invalidSessionExpired: "E_INVALIDSESSIONTOKEN_EXPIRED",
	sessionLimitExpired: "E_INVALIDSESSIONTOKEN_SESSIONLIMITEXPIRED",
	dailySessionLimitExpired: "E_INVALIDSESSIONTOKEN_DAILYSESSIONLIMITEXPIRED",
	weeklySessionLimitExpired: "E_INVALIDSESSIONTOKEN_WEEKLYSESSIONLIMITEXPIRED",
	monthlySessionLimitExpired: "E_INVALIDSESSIONTOKEN_MONTHLYSESSIONLIMITEXPIRED",
};

export const AUTH_PERSONAL_SESSION_LIMIT_EXPIRED_ERROR_CODES = [
	AUTH_INVALID_SESSION_ERROR_CODES.dailySessionLimitExpired,
	AUTH_INVALID_SESSION_ERROR_CODES.weeklySessionLimitExpired,
	AUTH_INVALID_SESSION_ERROR_CODES.monthlySessionLimitExpired,
];

export const AUTH_SESSION_LIMIT_EXPIRED_CODES = [
	...AUTH_PERSONAL_SESSION_LIMIT_EXPIRED_ERROR_CODES,
	AUTH_INVALID_SESSION_ERROR_CODES.sessionLimitExpired,
];

export const AUTH_WITH_CREDENTIALS_FAIL_ACTIONS = [
	SESSION_ACTION_TYPE.loginWithPersonalNumberFail,
	SESSION_ACTION_TYPE.loginWithVerificationCodeFail,
	SESSION_ACTION_TYPE.loginFail,
];

export const CURRENT_LOGIN_SOURCE = new InjectionToken<CurrentLoginSource>("CURRENT_LOGIN_SOURCE");
